var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2672 5.79359C14.899 4.5095 13.5516 3.7537 12.3208 4.27298C8.629 5.83058 5.46664 8.4621 3.26143 11.8513C0.614346 15.9197 -0.475778 20.8067 0.191341 25.6143C0.85846 30.422 3.23801 34.8275 6.89283 38.0214C10.5476 41.2153 15.2322 42.9832 20.0859 43.0001C24.9396 43.017 29.6365 41.282 33.3135 38.1136C36.9905 34.9453 39.4008 30.5566 40.1014 25.7537C40.8021 20.9508 39.7461 16.0563 37.1275 11.9696C34.946 8.565 31.8021 5.91148 28.1212 4.32813C26.8941 3.80028 25.5415 4.54665 25.1643 5.82814C24.7872 7.10963 25.5322 8.43738 26.7384 9.01135C29.3081 10.2341 31.5019 12.1565 33.0544 14.5794C35.0446 17.6854 35.8471 21.4051 35.3146 25.0553C34.7821 28.7055 32.9503 32.041 30.1558 34.4489C27.3612 36.8568 23.7916 38.1755 20.1028 38.1626C16.414 38.1497 12.8537 36.8062 10.0761 34.3788C7.2984 31.9514 5.48994 28.6033 4.98293 24.9494C4.47592 21.2956 5.30441 17.5815 7.3162 14.4896C8.88556 12.0776 11.0928 10.1705 13.6709 8.96574C14.8812 8.40019 15.6354 7.07768 15.2672 5.79359Z",
    fill: "#F76411"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 2C17.4688 0.89543 18.3642 0 19.4688 0H20.8438C21.9483 0 22.8438 0.895431 22.8438 2V19.5C22.8438 20.6046 21.9483 21.5 20.8438 21.5H19.4688C18.3642 21.5 17.4688 20.6046 17.4688 19.5V2Z",
    fill: "#F76411"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.decc9bde8a63c2985379073bf5e46cfa.svg";
export { ForwardRef as ReactComponent };